import React, { useState } from "react";
import { Send, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { LEAD_STEPS } from "./mascotScript";

export const LeadForm = ({ topic, onBot, onUser, onDone }) => {
  const [step, setStep] = useState(0);
  const [data, setData] = useState({});
  const [value, setValue] = useState("");
  const [sending, setSending] = useState(false);
  const cur = LEAD_STEPS[step];

  const submit = async (e) => {
    e.preventDefault();
    const v = value.trim();
    if (!v) return;
    if (v.length < 2 || (cur.key === "phone" && v.replace(/\D/g, "").length < 10)) {
      onUser(v);
      setValue("");
      onBot(cur.key === "phone" ? "Hmm, preciso do telefone com DDD (ex: 11 90000-0000)." : "Pode escrever um pouquinho mais completo?");
      return;
    }
    const next = { ...data, [cur.key]: v };
    onUser(v);
    setValue("");
    setData(next);
    if (step < LEAD_STEPS.length - 1) {
      setStep(step + 1);
      onBot(LEAD_STEPS[step + 1].ask);
      return;
    }
    setSending(true);
    try {
      await api.post("/public/site-leads", { ...next, topic }, { silent: true });
      onBot(`Prontinho, ${next.name.split(" ")[0]}! Recebi seu contato e a equipe AMC vai falar com você em breve.`);
      onDone();
    } catch (err) {
      const msg = err?.response?.data?.detail;
      onBot(typeof msg === "string" ? msg : "Não consegui enviar agora. Confere o telefone com DDD e tenta de novo?");
      if (err?.response?.status === 429) { onDone(); return; }
      setStep(LEAD_STEPS.length - 1);
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={submit} className="flex gap-2 p-3 border-t border-slate-200 bg-white" data-testid="mascot-lead-form">
      <input autoFocus value={value} onChange={(e) => setValue(e.target.value)} type={cur.type || "text"}
        placeholder={cur.placeholder} data-testid={`mascot-lead-${cur.key}`} maxLength={160}
        className="flex-1 h-10 px-3 rounded-xl border border-slate-300 text-[14px] focus:outline-none focus:ring-2 focus:ring-[#7c3aed]/40" />
      <button type="submit" disabled={sending} data-testid="mascot-lead-send"
        className="w-10 h-10 rounded-xl bg-[#7c3aed] text-white flex items-center justify-center disabled:opacity-60 active:scale-95 transition-transform">
        {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
      </button>
    </form>
  );
};
